import React from 'react';
import PromptCard from './PromptCard';
import Icon from '../../../components/AppIcon';

const PromptResults = ({ 
  prompts = [], 
  onCopyPrompt, 
  onSavePrompt, 
  canSave = false,
  isLoading = false 
}) => {
  if (isLoading) {
    return (
      <div className="w-full max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h3 className="text-xl font-semibold text-text-primary mb-2">
            Generating Your Prompts...
          </h3>
          <p className="text-text-secondary">
            Our AI is analyzing your request and creating personalized suggestions
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3]?.map((index) => (
            <div key={index} className="bg-card border border-border rounded-lg p-6 animate-pulse">
              <div className="space-y-4">
                <div className="h-4 bg-muted rounded w-3/4"></div>
                <div className="h-3 bg-muted rounded w-1/2"></div>
                <div className="space-y-2">
                  <div className="h-3 bg-muted rounded"></div>
                  <div className="h-3 bg-muted rounded"></div>
                  <div className="h-3 bg-muted rounded w-5/6"></div>
                </div>
                <div className="flex space-x-2 pt-4">
                  <div className="h-8 bg-muted rounded w-20"></div>
                  <div className="h-8 bg-muted rounded w-16"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!prompts?.length) {
    return (
      <div className="w-full max-w-4xl mx-auto text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Lightbulb" size={32} color="var(--color-text-secondary)" />
        </div>
        <h3 className="text-lg font-medium text-text-primary mb-2">
          Ready to Generate Prompts
        </h3>
        <p className="text-text-secondary">
          Enter your requirements above and click "Generate Prompts" to get AI-powered suggestions
        </p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-6xl mx-auto">
      <div className="text-center mb-8">
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          Your AI-Generated Prompts
        </h3>
        <p className="text-text-secondary">
          Here are {prompts?.length} personalized suggestions based on your requirements
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {prompts?.map((prompt, index) => (
          <PromptCard
            key={prompt?.id || index}
            prompt={prompt}
            isRecommended={index === 0}
            onCopy={onCopyPrompt}
            onSave={onSavePrompt}
            canSave={canSave}
          />
        ))}
      </div>
      {prompts?.length > 0 && (
        <div className="text-center mt-8 p-4 bg-muted/50 rounded-lg">
          <p className="text-sm text-text-secondary flex items-center justify-center space-x-2">
            <Icon name="Info" size={16} />
            <span>
              Need different suggestions? Modify your input and generate new prompts
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

export default PromptResults;